// extracted by mini-css-extract-plugin
export default {"zoomModal":"p3-z","image":"q3-z","button":"r3-z","isOverlayShown":"s3-z"};